import { render, staticRenderFns } from "./RgpLensesAdminHome.vue?vue&type=template&id=2bcb69f0&scoped=true&"
import script from "./RgpLensesAdminHome.vue?vue&type=script&lang=js&"
export * from "./RgpLensesAdminHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcb69f0",
  null
  
)

export default component.exports